import PageComponent from '../PageComponent';
import axios from "axios";

export default class SSRHeroModule extends PageComponent {
    init() {
        this.ready();
    }

    ready() {
        this.element.find('.fa-long-arrow-down').on('click', () => {
            let nonStickyContainer = $('#content-modules');
            if (nonStickyContainer.length) {
                nonStickyContainer[0].scrollIntoView({behavior: 'smooth'});
            }
        });

        this.element.find('.fa-times').on('click', (e) => {
            let noticeID = $(e.target).data('notice-id'),
                container = $(e.target).closest('.notice');
            if (container && container.length && noticeID && noticeID > 0) {
                axios.get(window.location.origin + '/settings/closeNotice/' + noticeID);
                container.hide();
            }
        });

        // this.initMarquee();
        // $(window).resize(() => {
        //     this.initMarquee();
        // });
    }

    initMarquee() {
        let messages = this.element.find('p.message');
        messages.each(function () {
            if ($(this)[0].offsetWidth < $(this)[0].scrollWidth) {
                $(this).addClass('overflow');
            } else {
                $(this).removeClass('overflow');
            }
        });
    }
}
